import UnderConstruction from '../components/UnderConstruction';

function Default(props){
    return(
        <UnderConstruction/>
    )
}

export default Default;